const mySwiper = new Swiper('.Slider .swiper', {
  initialSlide: 1,
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  loopAdditionalSlides: 1,
  speed: 1500,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
  },
  grabCursor: true,
  watchSlidesProgress: true,
  breakpoints: {
    990: {
      slidesPerView: 2,
    }
  },
});
